<script>
    import { createEventDispatcher } from "svelte";
    import addVariant from "src/utility/variant";
    import FormGroup from "./FormGroup.svelte";

    const dispatch = createEventDispatcher();

    export let variant;
    export let type;
    export let label;
    export let value;
    export let placeholder;

    export let options;
    export let messages = [];

    /** @type {HTMLInputElement} */
    let node;

    $: if (node) {
        node.value = value || "";
    }

    const handleInput = (e) => {
        value = type.match(/^(number|range)$/) ? +e.target.value : e.target.value;
        dispatch("change", value);
    };
</script>

<FormGroup {variant} {label} {messages}>
    {#if type == "select"}
    <!-- svelte-ignore a11y-no-onchange -->
    <select
        bind:this={node}
        use:addVariant={variant}
        class="pc__field pc__field--select"
        bind:value
        on:change={handleInput}>
        {#each options as option}
        <option value={option.value}>{option.label}</option>
        {/each}
    </select>
    {:else if type == "color"}
    <input
        bind:this={node}
        use:addVariant={variant}
        type="color"
        class="pc__field pc__field--color-picker"
        {value}
        on:input={handleInput} />
    {:else}
    <input
        bind:this={node}
        use:addVariant={variant}
        class="pc__field"
        {type}
        {value}
        {placeholder}
        on:input={handleInput} />
    {/if}
</FormGroup>